import {Component, Input, OnInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import {DecimalPipe} from '@angular/common';
import {StorageService} from '../../../../Services/storage.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {PermissionsService} from '../../../../Services/permissions.service';


@Component({
  selector: 'app-entity-history',
  templateUrl: './entity-history.component.html',
  styleUrls: ['./entity-history.component.css'],
  standalone: false
})
export class EntityHistoryComponent implements OnInit {
  @Input() entityHistoryID: string;

  vm: any = {};
  searchReceivablePayments;
  searchReceivableInvoices;
  paid = false;
  t: any = [];
  t2 = 0;
  t3 = 0;
  t4 = 0;
  t5 = 0;
  loaded = false;


  constructor(
    private table: DataService,
    private toast: BsToastService,
    private localStorage: StorageService,
    private decimal: DecimalPipe,
    private permissionsService: PermissionsService) {

    this.vm.permissions = {};
    this.vm.searchRecentItems = {};
    this.vm.searchTopItems = {};
  }

  get hasReceivablePaymentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivablePayments') ||
      this.permissionsService.Get('ViewReceivablePayments');
  }

  get hasReceivableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivableInvoices') ||
      this.permissionsService.Get('ViewReceivableInvoices');
  }

  get hasPayableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditPayableInvoices') ||
      this.permissionsService.Get('ViewPayableInvoices');
  }

  get hasPayablePaymentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditPayablePayments') ||
      this.permissionsService.Get('ViewPayablePayments');
  }

  ngOnInit() {
    this.vm.history = {};
    this.vm.history.Pricing = [];
    this.vm.history.RecentItems = [];
    this.vm.history.TopItems = [];
    this.vm.history.Taxes = {};
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    if (this.entityHistoryID){
      this.loadHistory();
    }
  }

  loadHistory() {
    this.table.getData('entity_history', this.entityHistoryID).subscribe((result: any) => {
        this.vm.history = result;
        this.loaded = true;
        // console.log(this.vm.history);
      },
      (error: HttpErrorResponse) => {
        // this.toast.error(error.message, $localize`:Error loading balance @@errorloadingbalance:Error loading balance`, {
        //   timeOut: 4000
        // });
        console.log(error);
      },
      () => {
     });
  }
}
